// Block that are displayed by default without being configured via the CMS
export const DEFAULT_BLOCK_TYPE = {
  BREADCRUMB: 'Breadcrumb',
  HERO_BANNER: 'HeroBanner',
  HEADING: 'Heading',
}
